import { useEffect, useState } from 'react';

import { mapGridIndexes } from '@shared/commonFunctions';
import { RelativeWrapper } from '@shared/styledComponents';
import { useQueryState } from '@shared/hooks/useQueryState';
import { LocalTabContent } from '@styles/CommonStyles';
import { FieldWrapper, FormWrapper } from '@styles/StyledDiv';
import { ILenderUtilityTabProps } from '../LenderUtilityTabs';
import { TCard, TTier } from '../../interfaces';
import { Cards } from './components/Cards/Cards';
import { Tiers } from './components/Tiers/Tiers';
import { Conditions } from './components/Conditions/Conditions';

const dateInDistantPast = '1990-01-01T00:00:00';

export const RateCards = ({ data, lenderId, mutate }: ILenderUtilityTabProps) => {
  const [prevCards, setPrevCards] = useState(data?.cards);
  const cards = data?.cards || prevCards || [];
  const [selectedCardId, setSelectedCardId] = useQueryState('cardId');
  const [selectedTierId, setSelectedTierId] = useQueryState('tierId');

  const selectedCard: TCard | undefined = cards.find((card) => card.id === selectedCardId);
  const selectedTier: TTier | undefined = selectedCard?.tiers?.find((tier) => tier.id === selectedTierId);

  useEffect(() => {
    cards && setPrevCards(cards);
    const sortedCards = [...cards].sort((a, b) => {
      const fromDateA = a.fromDate || dateInDistantPast;
      const fromDateB = b.fromDate || dateInDistantPast;

      return new Date(fromDateB).getTime() - new Date(fromDateA).getTime();
    });
    const firstCard = sortedCards?.[0];
    const firstCardsTier = firstCard?.tiers?.[0] || {};

    setSelectedCardId(firstCard?.id);
    !selectedTierId && setSelectedTierId(firstCardsTier?.id);
  }, [cards]);

  useEffect(() => {
    !selectedTier && setSelectedTierId(selectedCard?.tiers?.[0]?.id);
  }, [selectedCard]);

  return (
    <RelativeWrapper>
      <LocalTabContent>
        <FieldWrapper>
        <FormWrapper>
          <Cards
            lenderId={lenderId}
            data={cards}
            selectedRowId={selectedCard?.id}
            lenderData={data}
            onSelectRow={({ id }) => setSelectedCardId(id)}
          />
          </FormWrapper>
          <FormWrapper>
            <Tiers
              lenderId={lenderId}
              cardId={selectedCard?.id}
              mutate={mutate}
              data={mapGridIndexes(selectedCard?.tiers)}
              selectedRowId={selectedTier?.id}
              onSelectRow={({ id }) => setSelectedTierId(id)}
            />
          </FormWrapper>
          <FormWrapper>
          <Conditions
            lenderId={lenderId}
            tierId={selectedTier?.id}
            data={mapGridIndexes(selectedTier?.tierConditions)}
          />
          </FormWrapper>
        </FieldWrapper>
      </LocalTabContent>
    </RelativeWrapper>
  );
};
